import React from 'react';
import { Grid, Message } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../../common/GridColumnInputWrapper';
import { AccordionWrapper, AdvancedDatePickerWrapper } from 'react-lib/dist/components-es';
import { Mode } from '../../../../../constants';
import {
  TableFileViewerWrapper,
  InputWithLabelWrapper,
  FileInputWrapper,
} from 'react-lib/dist/components-es';
import CurrentRemoveDateButtonsWrapper from '../../../../common/CurrentRemoveDateButtonsWrapper';
import { InputWrapper } from 'react-lib/dist/components-es';
import CPSdsSearchModal from './CPSdsSearchModal';
import connect from 'react-redux/es/connect/connect';
import Connector from '../../../../../agent';
import NewTableFileViewerWrapper from '../TableFileViewerWrapper';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { toast } from 'react-toastify';

const { api } = Connector;

class CPSdsContainer extends React.Component {
  componentDidMount() {
    document.addEventListener(
      'dragover',
      function (event) {
        event.preventDefault();
        if (event.target.className === 'fileWrapperUploader') {
          event.target.style.backgroundColor = 'rgba(0,0,0,0.1)';
        } else if (event.target.id === 'chemicalProduct.sdsFiles') {
          let parent = document.getElementsByClassName('fileWrapperUploader')[0];
          parent && (parent.style.backgroundColor = 'rgba(0,0,0,0.1)');
        }
      },
      false
    );

    document.addEventListener(
      'dragleave',
      function (event) {
        if (event.target.className === 'fileWrapperUploader') {
          event.target.style.backgroundColor = 'rgba(0,0,0,0)';
        } else if (event.target.id === 'chemicalProduct.sdsFiles') {
          let parent = document.getElementsByClassName('fileWrapperUploader')[0];
          parent && (parent.style.backgroundColor = 'rgba(0,0,0,0)');
        }
      },
      false
    );

    document.addEventListener(
      'drop',
      function (event) {
        if (event.target.className === 'fileWrapperUploader') {
          event.target.style.backgroundColor = 'rgba(0,0,0,0)';
        } else if (event.target.id === 'chemicalProduct.sdsFiles') {
          let parent = document.getElementsByClassName('fileWrapperUploader')[0];
          parent && (parent.style.backgroundColor = 'rgba(0,0,0,0)');
        }
      },
      false
    );
  }

  render() {
    return (
      <AccordionWrapper
        {...this.props}
        closable={false}
        accordionTitle="chemical.product.details.page.sds.container.title"
        tooltip="chemical.product.details.page.sds.container.tooltip"
        render={this.getSdsContainerContent}
        className=""
        isRequired={true}
      />
    );
  }

  getWarning = () => {
    const { t, mode, isChemProdRouter, values } = this.props;
    let warning = { msg: 'chemical.product.details.page.chemical.container.sds.file.warning' };

    return (
      ((isChemProdRouter && mode !== Mode.VIEW) ||
        (!isChemProdRouter && values.chemicalProduct?.selectedChemicalProduct?.id === -1)) && (
        <div className="containerReducedWhiteSpace">
          <Message color="yellow">{t(warning.msg, warning.params)}</Message>
        </div>
      )
    );
  };

  handleCopyDownloadBtn = () => {
    const { t } = this.props;
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const downloadLink = `${baseUrl}/files/sdsFileDownload/${this.props.values.chemicalProduct.id}`;

    navigator.clipboard
      .writeText(downloadLink)
      .then(() => {
        toast.success(
          t('chemical.product.details.page.chemical.container.sds.download.link.copy.success')
        );
      })
      .catch(err =>
        toast.error(
          t('chemical.product.details.page.chemical.container.sds.download.link.copy.error')
        )
      );
  };

  getSdsContainerContent = () => {
    if (!this.props.values.chemicalProduct.sdsFiles)
      this.props.values.chemicalProduct.sdsFiles = [];

    return (
      <div className="sdsfilecontainer">
        <Grid stackable columns={1} verticalAlign="bottom">
          <Grid.Column>{this.getWarning()}</Grid.Column>
          {this.getFileWrapper()}
          <Grid.Column>{this.props.values.chemicalProduct.sdsFiles.length > 0 && (
              <ButtonWrapper
                  label="chemical.product.details.page.sds.file.copy.download.link"
                  onClick={this.handleCopyDownloadBtn}
                  icon="share alternate"
              />
          )}</Grid.Column>
        </Grid>
      </div>
    );
  };

  getFileWrapper = () => {
    const { values, disabled, chemicalProductDisabled, isHistory } = this.props;

    return (
      <>
        <GridColumnInputWrapper
          {...this.props}
          name="chemicalProduct.sdsFiles"
          fileDataProp="fileData"
          disabled={disabled || chemicalProductDisabled}
          value={values.chemicalProduct.sdsFiles}
          displayOnlyFirstLevelErrors={true}
          fieldClassName="sdsFiles"
          render={props => (
            <FileInputWrapper
              {...props}
              errors={this.props.errors}
              multiple={true}
              errorPaths={['.format', '.size']}
              hideFile={f =>
                (f[props.fileDataProp].deleted || f[props.fileDataProp].delUser) && !isHistory
              }
              fileViewerRender={props => this.getFileViewerRender(props)}
            />
          )}
        />
        {!disabled && !chemicalProductDisabled ? (
          <Grid.Column>
            <CPSdsSearchModal
              chemicalProduct={values.chemicalProduct}
              getFileViewerRender={this.getFileViewerRender}
            />
          </Grid.Column>
        ) : null}
      </>
    );
  };

  getFileViewerRender = props => {
    return (
      <>
        <NewTableFileViewerWrapper
          {...props}
          api={api}
          filesHeaderIcon="file pdf"
          extraColumns={[
            {
              label: 'chemical.product.details.page.sds.container.revision.date',
              width: 5,
              render: props => (
                <InputWithLabelWrapper
                  {...props}
                  name={`${props.name}[${props.fIndex}].revisionDte`}
                  className="inputWithTwoInputDefaultButtons"
                  render={props => (
                    <AdvancedDatePickerWrapper
                      name={props.name}
                      setFieldValue={props.setFieldValue}
                      value={props.f.revisionDte}
                      openDirection="up"
                      noBorder
                      renderDefaultButtons={
                        <CurrentRemoveDateButtonsWrapper {...props} dteName={props.name} />
                      }
                    />
                  )}
                />
              ),
            },
            {
              label: 'chemical.product.details.page.sds.container.not.conform.label',
              width: 2,
              render: props => (
                <InputWithLabelWrapper
                  {...props}
                  name={`${props.name}[${props.fIndex}].notConform`}
                  value={props.f.notConform}
                  render={props => <InputWrapper type="checkbox" {...props} />}
                />
              ),
            },
          ]}
        />
      </>
    );
  };
}

const mapStateToProps = state => ({
  sdsSearchModalOpen: state.sdsSearchModal.open,
});

export default connect(mapStateToProps, null)(CPSdsContainer);
